module.exports = __webpack_public_path__ + "static/media/policy-check.696107fd.svg";